var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "group-paywall-illustration" }, [
    _c(
      "svg",
      {
        attrs: {
          width: "272",
          height: "108",
          viewBox: "0 0 272 108",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }
      },
      [
        _c("path", {
          attrs: {
            d:
              "M169.462 25.5967L187.122 0.822266L224.857 6.13107L238.188 42.2815L235.023 56.6912L259.659 100.173L267.841 101.69L271.557 106.746H186.111V103.459L193.31 97.8976L182.903 78.6848L178.021 74.64L182.824 61.2416L169.462 25.5967Z",
            fill: "#179E7E"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M226.474 57.2738L231.526 54.8995L230.365 71.5843L224.597 67.1772L226.474 57.2738Z",
            fill: "#178268"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M219.943 14.1116L225.318 10.5724L228.583 20.6844L226.162 23.6462L219.943 14.1116Z",
            fill: "#178268"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M234.685 75.1564L238.092 75.1564L237.175 79.995L232.626 78.9733L234.685 75.1564Z",
            fill: "#178268"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M233.638 103.964L251.52 99.4141L258.781 101.436",
            stroke: "black",
            "stroke-width": "1.0112"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M195.212 91.831V95.3702H198.928L202.18 91.831L207.289 89.8086",
            stroke: "black",
            "stroke-width": "1.0112"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M225.043 32.6738V43.0386L228.294 45.061L229.456 38.2354",
            stroke: "black",
            "stroke-width": "1.0112"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M183.078 68.8268L191.926 60.4844L195.212 78.1804L190.409 92.59L179.791 89.8092L177.263 92.59H172.966L171.702 88.5452L156.787 77.1692L152.742 62.5068H161.084L168.921 68.8268H183.078Z",
            fill: "#179E7E"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M167.093 81.6921L169.924 81.6921L169.162 77.6716L165.382 78.5205L167.093 81.6921Z",
            fill: "#178268"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M180.802 71.6053L183.836 69.3301L185.605 76.6613L183.33 77.9253L180.802 71.6053Z",
            fill: "#19866C"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M177.516 38.4206L181.882 42.7871H190.339L194.706 38.4206V29.9632L190.339 25.5967H181.882L177.516 29.9632V38.4206Z",
            fill: "white"
          }
        }),
        _vm._v(" "),
        _c("rect", {
          attrs: {
            width: "3.0336",
            height: "3.0336",
            transform: "matrix(1 0 0 -1 181.561 35.7109)",
            fill: "black"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M195.212 49.3613H181.561",
            stroke: "black",
            "stroke-width": "1.0112"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M186.617 54.416L183.583 51.3824",
            stroke: "black",
            "stroke-width": "1.0112"
          }
        }),
        _vm._v(" "),
        _c("rect", {
          attrs: {
            x: "134.034",
            y: "18.0115",
            width: "33.3697",
            height: "43.9873",
            fill: "white",
            stroke: "black",
            "stroke-width": "1.0112"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M135.821 19.8086H165.618V60.2026H135.821V19.8086Z",
            fill: "#EEA71F"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M140.964 42.8833V37.1273L143.257 32.8648L147.165 30.3477H150.537H154.264L158.081 32.8648L160.465 37.1273V42.8833L158.081 47.1838L154.264 49.6629H150.537H147.165L143.257 47.1838L140.964 42.8833Z",
            stroke: "white",
            "stroke-width": "1.0112"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M150.714 30.4414V49.6424",
            stroke: "white",
            "stroke-width": "1.0112"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M144.849 31.832L147.314 38.6904L150.726 43.8315",
            stroke: "white",
            "stroke-width": "1.0112"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M156.59 31.832L154.125 38.6904L150.713 43.8315",
            stroke: "white",
            "stroke-width": "1.0112"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M147.247 30.3574L146.125 34.981",
            stroke: "white",
            "stroke-width": "1.0112"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M154.192 30.3574L155.313 34.981",
            stroke: "white",
            "stroke-width": "1.0112"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M145.383 48.459L150.726 43.832",
            stroke: "white",
            "stroke-width": "1.0112"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M156.056 48.459L150.713 43.832",
            stroke: "white",
            "stroke-width": "1.0112"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M142.423 34.3887L146.121 34.9328L150.665 36.4174",
            stroke: "white",
            "stroke-width": "1.0112"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M159.015 34.3887L155.317 34.9328L150.773 36.4174",
            stroke: "white",
            "stroke-width": "1.0112"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M150.748 47.0566L147.08 47.0566L142.269 45.3503",
            stroke: "white",
            "stroke-width": "1.0112"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M150.691 47.0566L154.359 47.0566L159.17 45.3503",
            stroke: "white",
            "stroke-width": "1.0112"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M140.964 37.1931L142.482 40.0133L150.726 43.8705",
            stroke: "white",
            "stroke-width": "1.0112"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M160.475 37.1931L158.957 40.0133L150.713 43.8705",
            stroke: "white",
            "stroke-width": "1.0112"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M142.212 45.0873L150.683 43.8711",
            stroke: "white",
            "stroke-width": "1.0112"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M159.226 45.0873L150.756 43.8711",
            stroke: "white",
            "stroke-width": "1.0112"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M142.175 45.0491L144.676 41.1178L150.764 36.4065",
            stroke: "white",
            "stroke-width": "1.0112"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M159.264 45.0491L156.763 41.1178L150.675 36.4065",
            stroke: "white",
            "stroke-width": "1.0112"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M142.081 44.8794L142.509 39.4145L143.579 36.7477L146.039 34.9881L150.688 33.1316",
            stroke: "white",
            "stroke-width": "1.0112"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M159.358 44.8794L158.93 39.4145L157.86 36.7477L155.399 34.9881L150.751 33.1316",
            stroke: "white",
            "stroke-width": "1.0112"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M150.714 30.4414L146.068 34.776L144.66 41.2604L146.897 46.7281L150.714 49.6424",
            stroke: "white",
            "stroke-width": "1.0112"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M150.725 30.4414L155.425 34.9821L156.779 41.2604L154.542 46.7281L150.725 49.6424",
            stroke: "white",
            "stroke-width": "1.0112"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M88.3256 67.7004L68.1357 47.3379L32.822 52.1169L19.9397 77.3276L23.5666 79.4055L9.82771 101.943L3.49771 103.023L0.44355 107.179H86.9013V104.478L81.7068 103.023L87.1828 92.4264L89.3779 88.4786L81.1699 79.821L88.3256 67.7004Z",
            fill: "#179E7E"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M32.3257 68.8995L28.6249 66.1876L26.9307 79.8295L32.2782 77.184L32.3257 68.8995Z",
            fill: "#178268"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M31.1204 84.2573L28.3721 83.7201L28.3489 87.7677L32.1795 87.6609L31.1204 84.2573Z",
            fill: "#178268"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M34.7251 104.894L20.027 101.154L12.0738 103.208",
            stroke: "black",
            "stroke-width": "1.0112"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M81.1538 91.1798V94.0888H78.0997L75.4273 91.1798L71.2278 89.5176",
            stroke: "black",
            "stroke-width": "1.0112"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M39.6279 55.0938V63.6128L35.5831 64.7726L34.6287 59.1625",
            stroke: "black",
            "stroke-width": "1.0112"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M75.0215 78.1806H119.796L124.823 68.5742",
            stroke: "#179E7E",
            "stroke-width": "6.06721"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M81.4409 64.5293H64.6573",
            stroke: "black",
            "stroke-width": "1.0112"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M66.1748 63.0137L63.6468 65.5417",
            stroke: "black",
            "stroke-width": "1.0112"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M53.7886 50.6224L52.019 40.5104L55.0526 37.9824H81.3439",
            stroke: "#179E7E",
            "stroke-width": "7.07841"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M100.556 32.0014L95.1622 26.6074H84.7149L79.3209 32.0014V42.4487L84.7149 47.8427H95.1622L100.556 42.4487V32.0014Z",
            fill: "#179E7E"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M102.074 32.9935L97.7072 28.627H89.2499L84.8833 32.9935V41.4508L89.2499 45.8174H97.7072L102.074 41.4508V32.9935Z",
            fill: "white"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d:
              "M104.095 32.1587L98.544 26.6074H88.4112L82.86 32.1587V42.2914L88.4112 47.8427H98.544L104.095 42.2914V32.1587ZM97.7063 28.6298L102.073 32.9964V41.4537L97.7063 45.8203H89.2489L84.8824 41.4537V32.9964L89.2489 28.6298H97.7063Z",
            fill: "#179E7E"
          }
        }),
        _vm._v(" "),
        _c("rect", {
          attrs: {
            width: "3.0336",
            height: "3.0336",
            transform: "matrix(-1 0 0 1 98.0283 35.709)",
            fill: "black"
          }
        }),
        _vm._v(" "),
        _c("rect", {
          attrs: {
            x: "108.138",
            y: "22.0583",
            width: "33.3697",
            height: "43.9873",
            fill: "white",
            stroke: "black",
            "stroke-width": "1.0112"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M109.925 23.8555H139.722V64.2495H109.925V23.8555Z",
            fill: "#E1503C"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M115.068 46.9302V41.1742L117.361 36.9117L121.269 34.3945H124.641H128.368L132.185 36.9117L134.569 41.1742V46.9302L132.185 51.2307L128.368 53.7098H124.641H121.269L117.361 51.2307L115.068 46.9302Z",
            stroke: "white",
            "stroke-width": "1.0112"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M124.818 34.4883V53.6893",
            stroke: "white",
            "stroke-width": "1.0112"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M118.953 35.8789L121.418 42.7373L124.83 47.8784",
            stroke: "white",
            "stroke-width": "1.0112"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M130.694 35.8789L128.229 42.7373L124.817 47.8784",
            stroke: "white",
            "stroke-width": "1.0112"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M121.351 34.4043L120.229 39.0279",
            stroke: "white",
            "stroke-width": "1.0112"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M128.296 34.4043L129.417 39.0279",
            stroke: "white",
            "stroke-width": "1.0112"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M119.487 52.5059L124.83 47.8789",
            stroke: "white",
            "stroke-width": "1.0112"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M130.16 52.5059L124.817 47.8789",
            stroke: "white",
            "stroke-width": "1.0112"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M116.527 38.4355L120.225 38.9796L124.769 40.4643",
            stroke: "white",
            "stroke-width": "1.0112"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M133.119 38.4355L129.421 38.9796L124.877 40.4643",
            stroke: "white",
            "stroke-width": "1.0112"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M124.852 51.1035L121.184 51.1035L116.373 49.3972",
            stroke: "white",
            "stroke-width": "1.0112"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M124.795 51.1035L128.463 51.1035L133.274 49.3972",
            stroke: "white",
            "stroke-width": "1.0112"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M115.068 41.24L116.586 44.0602L124.83 47.9174",
            stroke: "white",
            "stroke-width": "1.0112"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M134.579 41.24L133.061 44.0602L124.817 47.9174",
            stroke: "white",
            "stroke-width": "1.0112"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M116.316 49.1342L124.787 47.918",
            stroke: "white",
            "stroke-width": "1.0112"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M133.33 49.1342L124.86 47.918",
            stroke: "white",
            "stroke-width": "1.0112"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M116.279 49.0959L118.78 45.1646L124.868 40.4534",
            stroke: "white",
            "stroke-width": "1.0112"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M133.368 49.0959L130.867 45.1647L124.779 40.4534",
            stroke: "white",
            "stroke-width": "1.0112"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M116.185 48.9262L116.613 43.4614L117.683 40.7946L120.143 39.035L124.792 37.1785",
            stroke: "white",
            "stroke-width": "1.0112"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M133.462 48.9262L133.034 43.4614L131.964 40.7946L129.503 39.035L124.855 37.1785",
            stroke: "white",
            "stroke-width": "1.0112"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M124.818 34.4883L120.172 38.8228L118.764 45.3073L121.001 50.775L124.818 53.6893",
            stroke: "white",
            "stroke-width": "1.0112"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M124.829 34.4883L129.529 39.029L130.883 45.3073L128.646 50.775L124.829 53.6893",
            stroke: "white",
            "stroke-width": "1.0112"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M125.077 57.4473L127.352 58.7113L130.386 65.7897L127.352 70.0873L120.779 69.8345L119.01 66.5481H124.319V63.5145L122.549 60.2281L125.077 57.4473Z",
            fill: "#179E7E"
          }
        })
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }